// Function to check and update the bottom style
function checkAndUpdateBottomStyle() {
  // Update the site padding on body if attrac loads.

  const siteControlHeight =
    document.querySelector("#site-control").offsetHeight;
  document.documentElement.style.setProperty(
    "--nav-height",
    siteControlHeight + "px"
  );

  const cookieConsentDiv = document.querySelector(".cc-window");
  const targetDiv = document.querySelector("#usntA40Toggle");

  // Check if the div is not hidden (display is not 'none')
  if (
    cookieConsentDiv &&
    getComputedStyle(cookieConsentDiv).display !== "none"
  ) {
    // Calculate the height of the cc-window + 10px
    const windowHeight = cookieConsentDiv.offsetHeight + 10;
    // Set the bottom style to height of cc-window + 10px
    if (targetDiv && targetDiv.style) {
      targetDiv.style.setProperty("bottom", `${windowHeight}px`, "important");
    }
  } else {
    // Only remove the 'bottom' style if it exists
    if (targetDiv && targetDiv.style.bottom) {
      targetDiv.style.removeProperty("bottom");
    }
  }
}

// Initial check on page load
document.addEventListener("DOMContentLoaded", () => {
  // Immediately call the function when the page is loaded
  checkAndUpdateBottomStyle();

  // Set up a MutationObserver to watch for any DOM changes
  const observer = new MutationObserver(() => {
    checkAndUpdateBottomStyle(); // Re-run the function on any DOM change
  });

  // Target the entire document for changes (subtree includes all child nodes)
  const config = {
    childList: true,
    subtree: true,
    attributes: true,
    characterData: true,
  };
  observer.observe(document.body, config);

  // Optional: You can also listen for clicks on the document to trigger the check manually
  document.addEventListener("click", checkAndUpdateBottomStyle);
});

// --------------------------------------
// CODE FOR READ MORE AND LESS
//-----------------------------------------

document.addEventListener("DOMContentLoaded", function () {
  const content = document.getElementById("unsubMoreLessContent");
  const button = document.getElementById("unsubMoreLessButton");

  if (content && button) {
    button.addEventListener("click", () => {
      if (content.classList.contains("unsub-more-less-show")) {
        content.classList.remove("unsub-more-less-show");
        button.textContent = "read less";
      } else {
        content.classList.add("unsub-more-less-show");
        button.textContent = "read less";
      }
    });
  }
});

// ============================================
// Custom Events to load swatch preview.
// =======================================
document.addEventListener("DOMContentLoaded", () => {
  // Function to attach event listeners
  const attachEventListeners = () => {
    document.querySelectorAll(".click-swatch-preview").forEach((element) => {
      element.removeEventListener("click", handleClick); // Ensure no duplicate events
      element.addEventListener("click", handleClick);
    });

    document.querySelectorAll(".product-block").forEach((element) => {
     if (!element.classList.contains('not-primary-product-block')) {
        element.addEventListener("mouseenter", handleMouseOutSwatch);
     }

    });
  };

    const handleMouseOutSwatch = (event) => {
        const temporaryBlockImages = document.querySelectorAll('.image--hover-second-temporary-block');
        temporaryBlockImages.forEach(imageElement => {
            imageElement.classList.remove("image--hover-second-temporary-block");
            imageElement.classList.add("image--hover-second");
        });
    }
    const handleMouseInSwatch = (event) => {
        const temporaryBlockImages = document.querySelectorAll('.image--hover-second');
        temporaryBlockImages.forEach(imageElement => {
            imageElement.classList.add("image--hover-second-temporary-block");
            imageElement.classList.remove("image--hover-second");
        });
    }
  
  // Handle click event
  const handleClick = (event) => {
    const element = event.currentTarget;
    const mainValue = element.getAttribute("data-main");
    const subValue = element.getAttribute("data-sub");

    if (mainValue && subValue) {
      // Add "hidden" to all elements with class main_<mainValue>
      document.querySelectorAll(`.main_${mainValue}`).forEach((mainElement) => {
        mainElement.classList.add("hidden");
      });

      // Remove "hidden" from all elements with both classes main_<mainValue> and child_<subValue>
      document
        .querySelectorAll(`.main_${mainValue}.child_${subValue}`)
        .forEach((childElement) => {
          childElement.classList.remove("hidden");
        });

      document
        .querySelectorAll(`.main_${mainValue}.child_${subValue}`)
        .forEach((childElement) => {
    

          // Update elements with class image image--hover-second
          const hoverSecondImages = childElement.querySelectorAll(
            ".image.image--hover-second"
          );
          hoverSecondImages.forEach((imageElement) => {
            imageElement.classList.remove("image--hover-second");
            imageElement.classList.add("image--hover-second-temporary-block");
          });
        });
    }
  };

  // Attach the event listeners for the first time
  attachEventListeners();

  // Observe changes to the DOM and reattach event listeners
  const observer = new MutationObserver(() => {
    attachEventListeners();
  });

  // Start observing the body for child element additions/removals
  observer.observe(document.body, { childList: true, subtree: true });
});

// ============================================
// Ends Custom Events to load swatch preview.
// =======================================

// =========================================
// load more for to show additonal swatches
// =========================================
document.addEventListener("DOMContentLoaded", () => {
  // Function to add event listeners
  const addEventListeners = () => {
    document.querySelectorAll(".additional-color").forEach((element) => {
      element.removeEventListener("click", handleClick); // Remove any existing listener
      element.addEventListener("click", handleClick); // Add the click event listener
    });
  };

  // Click event handler
  const handleClick = function () {
    const mainProductId = this.getAttribute("data-parent");

    // Reveal elements with the matching data-main attribute
    const elementsToReveal = document.querySelectorAll(
      `[data-main="${mainProductId}"]`
    );
    elementsToReveal.forEach((el) => el.classList.remove("hidden"));

    // Hide all elements with the matching data-parent attribute
    const elementsToHide = document.querySelectorAll(
      `[data-parent="${mainProductId}"]`
    );
    elementsToHide.forEach((el) => el.classList.add("hidden"));
  };

  // Initial setup
  addEventListeners();

  // Watch for DOM changes
  const observer = new MutationObserver(() => {
    addEventListeners(); // Re-apply listeners on DOM changes
  });

  observer.observe(document.body, {
    childList: true, // Observe direct child additions/removals
    subtree: true, // Observe changes in all descendants
  });
});

// =========================================
// ends -- load more for to show additonal swatches
// =========================================

// =======================================================
// The code to display the count on the Gift Recipeint Message.
// =============================================================
document.addEventListener("DOMContentLoaded", function () {
  // Get references to the textarea and character count elements
  const textarea = document.getElementById("gift-card-recipient-message");
  const charCount = document.getElementById("char-count");

  // Check if both elements are available before proceeding
  if (textarea && charCount) {
    const maxChars = textarea.getAttribute("maxlength");

    // Function to update the character count
    function updateCharCount() {
      const currentLength = textarea.value.length;
      charCount.textContent = `${currentLength}/${maxChars}`;
    }

    // Event listener to track input in the textarea
    textarea.addEventListener("input", updateCharCount);

    // Initialize character count on page load
    updateCharCount();
  }
});
// =======================================================
// Ends. The code to display the count on the Gift Recipeint Message.
// =============================================================

// ==========================================================================
// custom validation for the gift page.
// ============================================================================

class CustomFormValidator {
  constructor(formId) {
    this.form = document.getElementById(formId);

    if (!this.form) {
      console.error(`Form with id "${formId}" not found.`);
      return;
    }

    // Add novalidate to disable native HTML validation
    this.form.setAttribute("novalidate", "true");

    this.fields = this.form.querySelectorAll("input, textarea, select");
    this.attachEventListeners();
    this.injectErrorContainers();
  }

  injectErrorContainers() {
    // Automatically add error containers after each field
    this.fields.forEach((field) => {
      // Skip hidden fields
      if (this.isHidden(field)) return;

      const errorContainerId = `${field.id || field.name}-un-error`; // Change -error to -un-error
      let errorContainer = document.getElementById(errorContainerId);

      // Create error container if it does not exist
      if (!errorContainer) {
        errorContainer = document.createElement("div");
        errorContainer.id = errorContainerId;
        errorContainer.className = "un-error-message"; // Use "un-error-message" class
        errorContainer.style.display = "none"; // Initially hidden
        field.insertAdjacentElement("afterend", errorContainer);
      }
    });
  }

  isHidden(field) {
    return (
      field.offsetParent === null ||
      window.getComputedStyle(field).display === "none"
    );
  }

  attachEventListeners() {
    // Add listeners for real-time validation
    this.fields.forEach((field) => {
      //  field.addEventListener("input", () => this.validateField(field));
    });

    // Add a listener for form submission
    this.form.addEventListener("submit", (event) => {
      event.preventDefault(); // Prevent default form submission
      event.stopPropagation();

      const isValid = this.validateForm();
      if (isValid) {
        console.log("Form is valid. Proceeding with submission...");
        //  this.form.submit(); // Submit the form programmatically
      }
    });
  }

  validateForm() {
    let isFormValid = true;
    let firstInvalidField = null;

    this.fields.forEach((field) => {
      if (this.isHidden(field)) return; // Skip hidden fields

      const isValid = this.validateField(field);
      if (!isValid && !firstInvalidField) {
        firstInvalidField = field;
      }
      isFormValid = isFormValid && isValid;
    });

    if (firstInvalidField) {
      firstInvalidField.scrollIntoView({ behavior: "smooth", block: "center" });
      firstInvalidField.focus();
    }

    return isFormValid;
  }

  validateField(field) {
    const errorContainerId = `${field.id || field.name}-un-error`; // Change -error to -un-error
    let errorContainer = document.getElementById(errorContainerId);

    // Ensure the error container exists
    if (!errorContainer) {
      errorContainer = document.createElement("div");
      errorContainer.id = errorContainerId;
      errorContainer.className = "un-error-message"; // Use "un-error-message" class
      errorContainer.style.display = "none"; // Initially hidden
      field.insertAdjacentElement("afterend", errorContainer);
    }

    // Reset error message and hide the error container
    errorContainer.textContent = "";
    errorContainer.style.display = "none"; // Hide by default

    // Perform validation checks
    if (field.validity.valueMissing) {
      errorContainer.textContent = "please fill out this field.";
      errorContainer.style.display = "block"; // Show error message if there is an error
      return false;
    }

    if (field.type === "email" && field.validity.typeMismatch) {
      errorContainer.textContent = "Please enter a valid email address.";
      errorContainer.style.display = "block"; // Show error message if there is an error
      return false;
    }

    if (field.type === "number" && field.validity.rangeOverflow) {
      errorContainer.textContent = `Value must be less than or equal to ${field.max}.`;
      errorContainer.style.display = "block"; // Show error message if there is an error
      return false;
    }

    if (field.type === "number" && field.validity.rangeUnderflow) {
      errorContainer.textContent = `Value must be greater than or equal to ${field.min}.`;
      errorContainer.style.display = "block"; // Show error message if there is an error
      return false;
    }

    if (
      field.hasAttribute("minlength") &&
      field.value.length < field.getAttribute("minlength")
    ) {
      errorContainer.textContent = `Please enter at least ${field.getAttribute(
        "minlength"
      )} characters.`;
      errorContainer.style.display = "block"; // Show error message if there is an error
      return false;
    }

    if (
      field.hasAttribute("maxlength") &&
      field.value.length > field.getAttribute("maxlength")
    ) {
      errorContainer.textContent = `Please enter no more than ${field.getAttribute(
        "maxlength"
      )} characters.`;
      errorContainer.style.display = "block"; // Show error message if there is an error
      return false;
    }

    return true;
  }
}

// Initialize the validation for the form
document.addEventListener("DOMContentLoaded", () => {
  const form = document.getElementById("product-form-template--18240530710680__main-8470515286168");
  
  if (form) {
    new CustomFormValidator("product-form-template--18240530710680__main-8470515286168");
  }
});

// ==========================================================================
// ends - custom validation for the gift page.
// ============================================================================

// ==========================================================================
// Disabling dates after three months and in the past
// ============================================================================

function setDateRange(inputId) {
  // Get today's date in the format YYYY-MM-DD
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const dd = String(today.getDate()).padStart(2, "0");
  const minDate = `${yyyy}-${mm}-${dd}`;

  // Calculate the date 90 days from today
  const maxDateObject = new Date();
  maxDateObject.setDate(today.getDate() + 90);
  const yyyyMax = maxDateObject.getFullYear();
  const mmMax = String(maxDateObject.getMonth() + 1).padStart(2, "0");
  const ddMax = String(maxDateObject.getDate()).padStart(2, "0");
  const maxDate = `${yyyyMax}-${mmMax}-${ddMax}`;

  // Find the input element and set min and max attributes
  const dateInput = document.getElementById(inputId);
  if (dateInput) {
    dateInput.min = minDate;
    dateInput.max = maxDate;
  }
}

// Apply on page load
document.addEventListener("DOMContentLoaded", () => {
  setDateRange("gift-card-recipient-send-on");
});

// Observe DOM changes for dynamically added elements
const observer = new MutationObserver(() => {
  setDateRange("gift-card-recipient-send-on");
});

observer.observe(document.body, { childList: true, subtree: true });

// ==========================================================================
// ends - Disabling dates after three months and in the past
// ============================================================================

// ==========================================================================
// When scroll stops adjust height 
// ============================================================================

let scrollTimeout;

function updateNavHeight() {
  const siteControlHeight = document.querySelector("#site-control").offsetHeight;
  document.documentElement.style.setProperty("--nav-height", siteControlHeight + "px");
}

// Call the function immediately when the page loads
updateNavHeight();

// Add a scroll event listener
window.addEventListener("scroll", () => {
  // Clear any existing timeout
  clearTimeout(scrollTimeout);

  // Set a timeout to call the function after scrolling stops
  scrollTimeout = setTimeout(() => {
    updateNavHeight();
  }, 400); // Adjust the delay (200ms) as needed for your application
});



// ==========================================================================
// ends - When scroll stops adjust height 
// ============================================================================





// ==========================================================================
// Gift Card : Activating the checkbox when the user comes back on the page. 
// ============================================================================

// Call synchronizeProperties on window load
window.onload = () => {
  // Query all instances of the custom element
  const giftCardElements = document.querySelectorAll('gift-card-recipient');
  giftCardElements.forEach(element => {
    // Ensure the method exists and is callable
    if (typeof element.synchronizeProperties === 'function') {
      element.synchronizeProperties();
    }
  });
};

// ==========================================================================
// Gift Card Ends: Activating the checkbox when the user comes back on the page. 
// ============================================================================



// ==========================================================================
// Size Chart : Function to buid tabs on the Products Page. 
// ============================================================================

function convertToTabs(containerId) {
    const container = document.getElementById(containerId);
    if (!container) return;

    // Create tab navigation
    const tabs = document.createElement("div");
    tabs.classList.add("unsub-tabs");

    // Get all tab sections
    const sections = container.children;
    const contentWrapper = document.createElement("div");

    Array.from(sections).forEach((section, index) => {
        const tabName = section.dataset.caption || `Tab ${index + 1}`; // Use data-caption or default name
        const sectionClass = `unsub-${section.classList[0]}`; // Unique prefixed class
        section.classList.add(sectionClass);

        const tabButton = document.createElement("div");
        tabButton.classList.add("unsub-tab");
        tabButton.textContent = tabName;
        tabButton.dataset.target = sectionClass;

        // Show first tab by default
        if (index === 0) {
            tabButton.classList.add("unsub-active");
            section.classList.add("unsub-active");
        }

        tabButton.addEventListener("click", function () {
            document.querySelectorAll(".unsub-tab").forEach(tab => tab.classList.remove("unsub-active"));
            document.querySelectorAll(".unsub-tab-content").forEach(content => content.style.display = "none");

            this.classList.add("unsub-active");
            document.querySelector(`.${this.dataset.target}`).style.display = "block";
        });

        tabs.appendChild(tabButton);
        section.classList.add("unsub-tab-content");
        section.style.display = index === 0 ? "block" : "none";
        contentWrapper.appendChild(section);
    });

    // Insert the new structure
    container.innerHTML = "";
    container.appendChild(tabs);
    container.appendChild(contentWrapper);
}

// Run function on page load
document.addEventListener("DOMContentLoaded", function () {
    convertToTabs("size_chart");
});



// ==========================================================================
// Ends - Size Chart : Function to buid tabs on the Products Page. 
// ============================================================================

// ==========================================================================
// Size Chart :  Transpose table on Mobile. 
// ============================================================================


function isMobile() {
    return window.innerWidth <= 768; // Adjust breakpoint if needed
}

function transposeTables() {
    const tables = document.querySelectorAll("#size_chart table");
    if (!tables.length) return;

    tables.forEach((table) => {
        const rows = Array.from(table.rows);
        const rowCount = rows.length;
        const colCount = rows[0].cells.length;

        // Only transpose if columns are more than rows
        if (colCount <= rowCount) return;

        const transposedData = [];
        const headerIndexes = new Set();

        // Create an array to store transposed data, preserving <th>
        for (let col = 0; col < colCount; col++) {
            transposedData[col] = [];
            for (let row = 0; row < rowCount; row++) {
                const cell = rows[row].cells[col];
                transposedData[col][row] = {
                    content: cell.innerHTML,
                    isHeader: cell.tagName.toLowerCase() === "th"
                };
                if (cell.tagName.toLowerCase() === "th") {
                    headerIndexes.add(col);
                }
            }
        }

        // Create new transposed table
        const newTable = document.createElement("table");
        newTable.className = table.className;

        transposedData.forEach((rowData, rowIndex) => {
            const row = newTable.insertRow();
            rowData.forEach((cellData, colIndex) => {
                const cell = headerIndexes.has(rowIndex) ? document.createElement("th") : row.insertCell();
                cell.innerHTML = cellData.content;
                row.appendChild(cell);
            });
        });

        // Replace the old table with the new transposed one
        table.parentNode.replaceChild(newTable, table);
    });
}


// Run the function on page load if mobile
if (isMobile()) {
    transposeTables();
}

// Optional: Recheck on window resize
window.addEventListener("resize", () => {
    if (isMobile()) {
        transposeTables();
    }
});

// ==========================================================================
// End : Size Chart :  Transpose table on Mobile. 
// ============================================================================


// ==========================================================================
// GA4 Banner Tracking for Top Banner
// ==========================================================================

document.addEventListener("DOMContentLoaded", function () {
    const banner = document.getElementById("aph_bar_wrapper_460599");

    if (!banner) return;

    // Track visibility using IntersectionObserver
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    console.log("Banner is visible to the user");

                    Shopify.analytics.publish("view_promotion", {
                        event: "view_promotion",
                        promotion_id: "PROMO1",
                        promotion_name: "Attrac",
                    });

                    observer.unobserve(banner); // Track only once
                }
            });
        },
        { threshold: 0.5 }
    );

    observer.observe(banner);

    // Track clicks only on the clickable banner sections
    banner.addEventListener("click", function (event) {
        const clickableBar = event.target.closest(".aph_bar_clickable");

        if (clickableBar) {
            const targetInput = clickableBar.querySelector(".aph_clickableBarTarget");
            if (targetInput && targetInput.value) {
                const destinationUrl = targetInput.value;
                console.log("Banner link clicked:", destinationUrl);

                Shopify.analytics.publish("select_promotion", {
                    event: "select_promotion",
                    promotion_id: "PROMO1",
                    promotion_name: "Attrac",
                    destination_url: destinationUrl, // Capture the link user is navigating to
                });
            }
        }
    });
});

// ==========================================================================
// GA4 Banner Tracking for Top Banner
// ==========================================================================






